import { render, staticRenderFns } from "./TouGeMobile.vue?vue&type=template&id=7f848c14&scoped=true"
import script from "./TouGeMobile.vue?vue&type=script&lang=js"
export * from "./TouGeMobile.vue?vue&type=script&lang=js"
import style0 from "./TouGeMobile.vue?vue&type=style&index=0&id=7f848c14&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f848c14",
  null
  
)

export default component.exports